import { getState } from '../store';

export type Page = 'Home' | 'Categories' | 'Chatbot' | 'Category' | 'Search' | 'Article';

const PageMap: Record<Page, string> = {
  Home: 'home',
  Category: 'category',
  Categories: 'categories',
  Article: 'article',
  Search: 'search',
  Chatbot: 'chatbot',
};

export const pageEnumToString = (page: Page): string => {
  return PageMap[page];
};

// Helper to get current page from widget URL
export const getCurrentPage = (): Page => {
  const {
    widget: { currentUrl },
  } = getState();

  if (!currentUrl) {
    return 'Home';
  }

  try {
    const url = new URL(currentUrl);
    const pathname = url.pathname;

    if (pathname.includes('/chatbot')) {
      return 'Chatbot';
    } else if (pathname.includes('/search')) {
      return 'Search';
    } else if (pathname.includes('/article/id/') || pathname.includes('/article/uri/')) {
      return 'Article';
    } else if (pathname.includes('/category')) {
      return 'Category';
    } else if (pathname.includes('/categories')) {
      return 'Categories';
    } else {
      return 'Home';
    }
  } catch (e) {
    return 'Home';
  }
};
